module.exports = __webpack_public_path__ + "img/7A7A7A_D9D9D9_BCBCBC_B4B4B4-256px.3fd714b7.png";